// ---------------------------------------------- modules import
import M from "materialize-css";
import React, {
  ChangeEvent,
  FormEvent,
  FunctionComponent,
  useEffect
} from "react";

import { IResetPasswordProps } from "./common";
import { ThemeContext } from "../../../contexts/themeContext";
import { pattern } from "../../../store/helpers/validationHelper";

// ---------------------------------------------- the component
const ResetPassword: FunctionComponent<IResetPasswordProps> = ({
  isNewPasswordValid,
  onChangePassword,
  onUpdatePassword
}) => {
  // ---------------------------------------------- handlers
  const handleChange = (e: ChangeEvent<HTMLInputElement>) =>
    onChangePassword(e.currentTarget.name, e.currentTarget.value);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onUpdatePassword();
  };

  // ---------------------------------------------- effects
  useEffect(() => {
    const modals = document.querySelectorAll(".modal");

    M.Modal.init(modals);
  }, []);

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <form className="card col s12 m8 offset-m2" onSubmit={handleSubmit}>
          <div className="card-content">
            <span style={{ fontSize: "0.75rem" }}>reset</span>

            <span className="card-title" style={{ marginBottom: "20px" }}>
              PASSWORD
            </span>

            <div className="input-field">
              <input
                type="password"
                id="password"
                name="password"
                className="validate"
                pattern={pattern.login.password.toString().slice(1, -1)}
                minLength={8}
                maxLength={200}
                onChange={handleChange}
                required
              />

              <label htmlFor="password">New password</label>
            </div>

            <div className="input-field">
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className="validate"
                pattern={pattern.login.password.toString().slice(1, -1)}
                minLength={8}
                maxLength={200}
                onChange={handleChange}
                required
              />

              <label htmlFor="confirmPassword">Confirm new password</label>
            </div>
          </div>

          <div
            className="card-action row right-align"
            style={{ marginBottom: "0" }}
          >
            <button
              type="button"
              className={`btn-small waves-effect waves-light modal-trigger ${
                isNewPasswordValid() ? "" : "disabled"
              }`}
              style={{ backgroundColor: theme.ui }}
              data-target="alert-password"
            >
              Reset
            </button>

            <div className="modal" id="alert-password">
              <div className="modal-content center">
                <h5>Confirm Reset</h5>

                <p>Are you sure you want to reset this user's password?</p>
              </div>

              <div className="modal-footer">
                <div className="container">
                  <button
                    type="submit"
                    className="btn modal-close"
                    style={{ backgroundColor: theme.ui }}
                  >
                    Yes, I'm sure
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </ThemeContext.Consumer>
  );
};

export default ResetPassword;
